const TAB = 'tab';
const TABS = 'tabs';
const SIDEPANEL = 'sidepanel';
const CONTENT_GROUP = 'content-group';
const PANEL = 'panel';
export { TAB, TABS, SIDEPANEL, CONTENT_GROUP, PANEL };
//# sourceMappingURL=constants.js.map